module.exports = __webpack_public_path__ + "static/inter-pool-0242dc6780dbb9b596b3b66ffcd50827.svg";